import React from "react";
import { Box, Typography } from "@mui/material";
import FieldHelpTooltip from "./FieldHelpTooltip";

export default function FieldLabelWithHelp({
  label,
  tooltip,
  color = "#0DA3E2",
  fontWeight = 500,
  sx,
}) {
  if (!label) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.25,
        mb: 0.5,
        ...sx,
      }}
    >
      <Typography
        variant="body2"
        sx={{
          textAlign: "left",
          color,
          fontWeight,
        }}
      >
        {label}
      </Typography>
      <FieldHelpTooltip title={tooltip} />
    </Box>
  );
}
